export enum PROVIDER_STATUS {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  PENDING_VERIFICATION = 'PENDING_VERIFICATION',
  PENDING_PAYMENT = 'PENDING_PAYMENT',
}
